/**
 * @param {string | { _id?: string, id?: string } | null | undefined} value
 * @returns {string}
 */
export function normalizeOwnedCourseId(value) {
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "object" && value._id != null) {
    return String(value._id);
  }
  if (typeof value === "object" && value.id != null) {
    return String(value.id);
  }
  return "";
}

/**
 * @param {{
 *   ownedCourseIds?: Array<string | { _id?: string, id?: string }>,
 *   cursosInscritos?: Array<string | { _id?: string, id?: string }>,
 * } | null | undefined} profile
 * @returns {string[]}
 */
export function extractOwnedCourseIds(profile) {
  if (!profile || typeof profile !== "object") {
    return [];
  }
  const fromOwnedField = Array.isArray(profile.ownedCourseIds) ? profile.ownedCourseIds : [];
  const fromEnrolled = Array.isArray(profile.cursosInscritos) ? profile.cursosInscritos : [];
  return [
    ...new Set([...fromOwnedField, ...fromEnrolled].map(normalizeOwnedCourseId).filter(Boolean)),
  ];
}

/**
 * @param {string | { _id?: string, id?: string } | null | undefined} courseId
 * @param {string[]} ownedIds
 * @returns {boolean}
 */
export function isCourseOwnedByUser(courseId, ownedIds) {
  const target = normalizeOwnedCourseId(courseId);
  if (!target || !Array.isArray(ownedIds)) {
    return false;
  }
  return ownedIds.some((id) => String(id) === target);
}

export const COURSE_ALREADY_OWNED_CODE = "COURSE_ALREADY_OWNED";
